import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/address.js'), 'address.js')
  resolveStoreModules(require('../store/aiPrompts.js'), 'aiPrompts.js')
  resolveStoreModules(require('../store/aiRequestLogs.js'), 'aiRequestLogs.js')
  resolveStoreModules(require('../store/blog.js'), 'blog.js')
  resolveStoreModules(require('../store/blogCategory.js'), 'blogCategory.js')
  resolveStoreModules(require('../store/cart.js'), 'cart.js')
  resolveStoreModules(require('../store/category.js'), 'category.js')
  resolveStoreModules(require('../store/collection.js'), 'collection.js')
  resolveStoreModules(require('../store/collectionProducts.js'), 'collectionProducts.js')
  resolveStoreModules(require('../store/comment.js'), 'comment.js')
  resolveStoreModules(require('../store/coupon.js'), 'coupon.js')
  resolveStoreModules(require('../store/customCategory.js'), 'customCategory.js')
  resolveStoreModules(require('../store/customDuty.js'), 'customDuty.js')
  resolveStoreModules(require('../store/dcSelect.js'), 'dcSelect.js')
  resolveStoreModules(require('../store/discount.js'), 'discount.js')
  resolveStoreModules(require('../store/location.js'), 'location.js')
  resolveStoreModules(require('../store/media.js'), 'media.js')
  resolveStoreModules(require('../store/metaKey.js'), 'metaKey.js')
  resolveStoreModules(require('../store/newsletter.js'), 'newsletter.js')
  resolveStoreModules(require('../store/notes.js'), 'notes.js')
  resolveStoreModules(require('../store/notification.js'), 'notification.js')
  resolveStoreModules(require('../store/notificationUnsubscriberRecord.js'), 'notificationUnsubscriberRecord.js')
  resolveStoreModules(require('../store/option.js'), 'option.js')
  resolveStoreModules(require('../store/optionValue.js'), 'optionValue.js')
  resolveStoreModules(require('../store/package.js'), 'package.js')
  resolveStoreModules(require('../store/page.js'), 'page.js')
  resolveStoreModules(require('../store/preferences.js'), 'preferences.js')
  resolveStoreModules(require('../store/product.js'), 'product.js')
  resolveStoreModules(require('../store/productEdit.js'), 'productEdit.js')
  resolveStoreModules(require('../store/productLabel.js'), 'productLabel.js')
  resolveStoreModules(require('../store/productType.js'), 'productType.js')
  resolveStoreModules(require('../store/review.js'), 'review.js')
  resolveStoreModules(require('../store/setting.js'), 'setting.js')
  resolveStoreModules(require('../store/settings.js'), 'settings.js')
  resolveStoreModules(require('../store/shippingProfile.js'), 'shippingProfile.js')
  resolveStoreModules(require('../store/slug.js'), 'slug.js')
  resolveStoreModules(require('../store/store.js'), 'store.js')
  resolveStoreModules(require('../store/tag.js'), 'tag.js')
  resolveStoreModules(require('../store/taxRate.js'), 'taxRate.js')
  resolveStoreModules(require('../store/theme.js'), 'theme.js')
  resolveStoreModules(require('../store/tickets.js'), 'tickets.js')
  resolveStoreModules(require('../store/tryOn.js'), 'tryOn.js')
  resolveStoreModules(require('../store/tryOnPreview.js'), 'tryOnPreview.js')
  resolveStoreModules(require('../store/user.js'), 'user.js')
  resolveStoreModules(require('../store/vendor.js'), 'vendor.js')
  resolveStoreModules(require('../store/webPushSubscriptionNotification.js'), 'webPushSubscriptionNotification.js')
  resolveStoreModules(require('../store/wishlist.js'), 'wishlist.js')
  resolveStoreModules(require('../store/zone.js'), 'zone.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
